module.exports = __webpack_public_path__ + "assets/img/ms-select.a38b4343.png";